import { getGSAP } from './_gsap.js';

export function initParagraphRevealAnimations() {
  const gsap = getGSAP();

  // Sélectionner tous les éléments avec data-animation="paragraph-reveal"
  const paragraphWrappers = document.querySelectorAll('[data-animation="paragraph-reveal"]');

  paragraphWrappers.forEach(wrapper => {
    const overlay = wrapper.querySelector('.paragraph-overlay');
    const paragraph = wrapper.querySelector('p');

    if (!overlay || !paragraph) {
      console.warn('Structure incorrecte pour paragraph-reveal:', wrapper);
      return;
    }

    // Récupérer la valeur de la variable CSS
    const initialLineHeight = parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--line-height-normal'));

    // Fixer la hauteur du wrapper avec le line-height de 2
    const wrapperHeight = wrapper.offsetHeight;
    gsap.set(wrapper, { height: wrapperHeight });

    // Configurer l'overlay
    gsap.set(overlay, {
      transformOrigin: 'bottom',
      y: '0%'
    });

    // Configurer le paragraphe avec un line-height de 2 au début
    gsap.set(paragraph, { lineHeight: 2 });

    // Créer l'animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: "top 80%",
        toggleActions: "play none none none",
        once: true
      }
    });

    tl.to(paragraph, {
      lineHeight: initialLineHeight,
      duration: 0.7,
      ease: "power2.out"
    }, 0)
    .to(overlay, {
      y: '100%',
      duration: 0.5,
      ease: "power2.inOut"
    }, 0);
  });
}